export const GetUrl = {
  API_URL: process.env.REACT_APP_BACKEND_URL,
  IMAGE_URL: process.env.REACT_APP_IMAGE_URL,
  REACT_APP_MERCHANDISE_ID:process.env.REACT_APP_MERCHANDISE_ID
};
